import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

export default class Table extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.state = {
      sorting: {
        id: props.defaultSorted.id,
        desc: props.defaultSorted.desc,
      },
    };
  }

  /* Handlers */

  sortingHandler(accessor) {
    const sorting = this.state.sorting;

    if (sorting.id === accessor) {
      sorting.desc = !sorting.desc;
    } else {
      sorting.id = accessor;
      sorting.desc = false;
    }

    this.setState({
      sorting,
    });

    this.props.sort({
      id: accessor,
      desc: sorting.desc,
    });
  }

  /* Methods */

  formatHighlight(value) {
    if (!this.props.highlight || !this.props.highlight.length || !value || typeof value !== 'string') {
      return value;
    }

    const highlight = this.props.highlight;
    const regEx = new RegExp(highlight, 'gi');
    const result = value.replace(regEx, (val) => {
      return `<span class="u-color-highlight">${val}</span>`;
    });

    return (<span dangerouslySetInnerHTML={{ __html: result }} />); // eslint-disable-line
  }

  /* Render */

  render() {
    return (
      <table className="table">
        {this.renderHeader()}
        {this.renderBody()}
      </table>
    );
  }

  renderHeader() {
    const { columns, showHeader } = this.props;

    if (!columns || !columns.length || !showHeader) return null;

    const headers = columns.map((column) => {
      const sorting = this.state.sorting;
      const descending = sorting.id === column.accessor && sorting.desc;
      const sorted = sorting.id === column.accessor;

      let onColumnClick = null;
      let sortClassNames = '';
      let sortDirectionClassNames = '';

      if (!column.disableHeader) {
        sortClassNames = classNames({ 'table-header__cell--sorted': sorted, 'table-header__cell--unsorted': !sorted });
        sortDirectionClassNames = classNames('icon', { 'icon-chevron-down': !descending, 'icon-chevron-up': descending });
        onColumnClick = () => this.sortingHandler(column.accessor);
      }

      const modifier = column.modifier ? `table-header__cell--${column.modifier}` : '';

      let header = (<span className={sortClassNames} />);

      if (!column.hidden) {
        header = (
          <span className={sortClassNames} onClick={onColumnClick} role="button">
            {column.header}<span className={sortDirectionClassNames} />
          </span>
        );
      }

      return (
        <th
          className={`table-header__cell ${modifier}`}
          key={`table-head-${column.accessor}`}
        >
          {header}
        </th>
      );
    });

    return (
      <thead className="table-header">
        <tr className="table-header__row">{headers}</tr>
      </thead>
    );
  }

  renderBody() {
    const { columns, rows } = this.props;

    if (!rows || !rows.length) {
      const columnSize = columns ? columns.length : 1;

      return (
        <tbody className="table-body">
          <tr className="table-body__row">
            <td className="table-body__cell" colSpan={columnSize}>
              <div className="table-body__cell__content">{this.props.noDataMessage}</div>
            </td>
          </tr>
        </tbody>
      );
    }

    const remappedRows = rows.map((row) => {
      const keyRow = row.id;
      let cells = [];

      if (columns && columns.length) {
        cells = columns.map((column) => {
          const keyCell = `${keyRow}-${column.accessor}`;

          let tableCell = null;

          const hasModifier = !!column.modifier;

          const tableCellClassName = classNames(
            'table-body__cell',
            { [`table-body__cell--${column.modifier}`]: hasModifier },
          );

          if (column.cell && typeof column.cell === 'function') {
            tableCell = column.cell(row);
          } else {
            tableCell = (<div className="table-body__cell__content">{this.formatHighlight(row[column.accessor])}</div>);
          }

          return (
            <td key={keyCell} className={tableCellClassName}>
              {tableCell}
            </td>
          );
        });
      } else {
        Object.keys(row).forEach((key) => {
          const keyCell = `${keyRow}-${row[key]}`;

          cells.push((
            <td key={keyCell} className="table-body__cell">
              <div className="table-body__cell__content">{this.formatHighlight(row[key])}</div>
            </td>
          ));
        });
      }

      return (
        <tr key={keyRow} onClick={() => this.props.rowClick(row)} className="table-body__row">
          {cells}
        </tr>
      );
    });

    return (
      <tbody className="table-body">
        {remappedRows}
      </tbody>
    );
  }
}

Table.defaultProps = {
  defaultSorted: {
    id: '',
    desc: false,
  },
  noDataMessage: (<FormattedMessage id="components.table.noTableData" />),
  showHeader: true,
};

Table.propTypes = {
  columns: PropTypes.array,
  defaultSorted: PropTypes.object,
  highlight: PropTypes.string,
  noDataMessage: PropTypes.any,
  rowClick: PropTypes.func,
  rows: PropTypes.array,
  showHeader: PropTypes.bool,
  sort: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/table/index.jsx